import type * as Types from 'app/types/graphql';

import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils/gatewayClient';
export type VariantPriceDeleteMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type VariantPriceDeleteMutationResponse = Pick<Types.Mutation, 'variantPriceDelete'>;

export const VariantPriceDeleteDocument = `
    mutation VariantPriceDelete($id: ID!) {
  variantPriceDelete(id: $id)
}
    `;

export const useVariantPriceDeleteMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    VariantPriceDeleteMutationResponse,
    TError,
    VariantPriceDeleteMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    VariantPriceDeleteMutationResponse,
    TError,
    VariantPriceDeleteMutationVariables,
    TContext
  >(
    ['VariantPriceDelete'],
    (variables?: VariantPriceDeleteMutationVariables) =>
      appFetcher<VariantPriceDeleteMutationResponse, VariantPriceDeleteMutationVariables>(
        VariantPriceDeleteDocument,
        variables,
      )(),
    options,
  );
};

useVariantPriceDeleteMutation.getKey = () => ['VariantPriceDelete'];
